import { fetcher } from '@commenda/utils';
import { BASE_URL } from './helpers';

export const deleteWorkflowTemplate = async (
  workflowId: string
): Promise<Response> => {
  const res = await fetcher(`${BASE_URL}/${workflowId}`, {
    method: 'DELETE',
  });
  return res;
};
